import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from '@polichat/flamboyant';
import { useState } from 'react';
import { useGlotaT } from '../../../../../../hooks/useGlotaTranslation';
import { LabelWithSpan } from '../../FormMessagesBuilder.styles';

function CreateOptionList({
  id,
  removeOption,
  onUpdate,
  initialValue,
  isDisabledRemove,
}) {
  const [optionData, setOptionData] = useState(initialValue);

  // Traduções
  const optionLabel = useGlotaT('spa.messageBuilder.list.option.label');
  const optionTitleDescription = useGlotaT('spa.messageBuilder.list.option.titleDescription');
  const optionTitlePlaceholder = useGlotaT('spa.messageBuilder.list.option.titlePlaceholder');
  const optionDescriptionLabel = useGlotaT('spa.messageBuilder.list.option.descriptionLabel');
  const optionDescriptionPlaceholder = useGlotaT('spa.messageBuilder.list.option.descriptionPlaceholder');
  const removeOptionButton = useGlotaT('spa.messageBuilder.list.option.removeButton');

  const handleInputChange = ({ target: { name, value } }) => {
    setOptionData({
      ...optionData,
      [name]: value,
    });
    handleOptionData({
      ...optionData,
      [name]: value,
    });
  };

  const handleOptionData = (data) => {
    onUpdate(data);
  };

  const handleWithDeleteOption = () => {
    setOptionData({});
    removeOption(id);
  };

  return (
    <Row>
      <Col sm={12}>
        <FormGroup>
          <LabelWithSpan>
            <Label>
              {optionLabel}: <span>{optionTitleDescription}</span>
            </Label>
          </LabelWithSpan>
          <Input
            type="text"
            id="option-message"
            name="title"
            placeholder={optionTitlePlaceholder}
            value={optionData.title}
            onChange={handleInputChange}
            showCharCounter
            maxLength={24}
            required
          />
          <LabelWithSpan>
            <Label>
              <span>{optionDescriptionLabel}</span>
            </Label>
          </LabelWithSpan>
          <Input
            type="text"
            id="option-description"
            name="description"
            placeholder={optionDescriptionPlaceholder}
            value={optionData.description}
            onChange={handleInputChange}
            showCharCounter
            maxLength={72}
            required
          />
          <br></br>
          <Button
            color="danger"
            onClick={handleWithDeleteOption}
            disabled={isDisabledRemove}
          >
            {removeOptionButton}
          </Button>
        </FormGroup>
      </Col>
    </Row>
  );
}

export default CreateOptionList;
